import React from 'react';
import './index.less';

import TablePropTypes from '../../prop-types';

import withIntl, { IntlPropType } from '../../../intl-hoc';

function TableBodyItem({ intl, columns, renderTD, row, payload }) {
	return (
		<tr className='new-table__body__item'>
			{columns.map((item) => renderTD(item, { ...payload, intl, row }))}
		</tr>
	);
}

TableBodyItem.propTypes = {
	intl: IntlPropType,
	columns: TablePropTypes.ColumnsPropType,
	renderTD: TablePropTypes.RenderPropType,
	row: TablePropTypes.RowPropType,
	payload: TablePropTypes.PayloadPropType
};

export default withIntl(TableBodyItem);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/components/TableBodyItem/index.js